import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ResultsService } from 'src/app/services/results/results.service';
import { SharedService } from 'src/app/services/shared/shared.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  private componentLoadedSubscription: any;

  isSearch = false;
  searchSelectedKey = '';
  dataList: any = [];
  isLoading: boolean = false;
  loadedSubscription: any;
  predictiveTexts: any = [];
  isSuggestionDisplayed: boolean = false;

  @ViewChild('searchKey') searchKey: any = '';
  encodedSearchHeader: string = btoa('SearchQuery');
  constructor(
    private resultsService: ResultsService,
    private sharedService: SharedService,
    private router: Router
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('current url', event.url); // event.url has current url
        if (
          event.url !== '/' &&
          !this.isSearch &&
          !event.url.includes('enc=')
        ) {
          this.isSearch = true;
        } else if (
          (event.url === '/' || event.url.includes('enc=')) &&
          this.isSearch
        ) {
          this.isSearch = false;
        }
        const dataPresent = sessionStorage.getItem(this.encodedSearchHeader);
        if (dataPresent) {
          this.searchSelectedKey = JSON.parse(atob(dataPresent) || '').Keywords;
        }
      }
    });
  }

  ngOnInit(): void {
    this.loadedSubscription = this.resultsService.variable$.subscribe(
      (newValue) => {
        if (newValue !== null) {
          this.isLoading = newValue;
        }
      }
    );
  }

  ngAfterViewInit(): void {
    this.componentLoadedSubscription = this.sharedService
      .getComponentLoadedSignal()
      .subscribe((loaded) => {
        if (loaded) {
          this.searchKey.nativeElement.focus();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.loadedSubscription) {
      this.loadedSubscription.unsubscribe();
    }
    if (this.componentLoadedSubscription) {
      this.componentLoadedSubscription.unsubscribe();
    }
  }

  navigation(event: any) {
    // this.resultsService.clearSearchResult();
    this.isLoading = true;
    let inputValue = event.value.trim();
    let data;
    let localData = sessionStorage.getItem(this.encodedSearchHeader);
    if (localData && localData !== '') {
      data = JSON.parse(atob(localData));
      data.Keywords = inputValue;
    } else {
      data = {
        ResultLocationList: [],
        ResultCollaboratorList: [],
        Keywords: inputValue,
      };
    }
    sessionStorage.setItem(
      this.encodedSearchHeader,
      btoa(JSON.stringify(data))
    );
    this.resultsService.updateSearchParams(JSON.stringify(data));
    this.router.navigate(['/search-result']);
  }

  search(event: any) {
    console.log(event.value);
    this.searchKey = event.value;
    if (this.searchKey === '') {
      this.dataList = [];
      return;
    }

    let data;
    data = {
      Keywords: this.searchKey,
    };

    this.resultsService.getResultsSearch(data).subscribe(
      (response: any) => {
        const val = 'Status';
        const res = 'Data';
        if (response[val] === true) {
          this.dataList = response[res];
        } else {
          console.log('Something went wrong');
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  updateSearch(event: any) {
    let inputValue = event.value.trim();
    this.resultsService.storeData(inputValue);
  }

  searchFocus() {
    this.isSuggestionDisplayed = true;
  }
  searchBlur() {
    setTimeout(() => {
      this.isSuggestionDisplayed = false;
    }, 500);
  }

  onInputChange(event: any) {
    if (this.searchKey.nativeElement.value.length > 3) {
      const obj = sessionStorage.getItem(this.encodedSearchHeader);
      const data = obj ? JSON.parse(atob(obj)) : '';
      data.Keywords = this.searchKey.nativeElement.value;
      this.resultsService
        .getPredictiveTexts(data)
        .subscribe((response: any) => {
          const val = 'Status';
          const res = 'Data';
          if (response[val] === true) {
            this.predictiveTexts = response[res];
            // this.predictiveTexts=text.map((trial: any) => trial.Title);
          }
        });
    } else {
      this.predictiveTexts = [];
    }
  }

  selectSuggestion(text: any) {
    this.searchKey.nativeElement.value = text.Title;
    this.predictiveTexts = [];
    this.navigation(this.searchKey.nativeElement);
  }
}
